<template>
    <div class="dashboard-container">
        <Sidebar />
        
        <main class="main-content">
            <header class="header-dashboard">
                <div>
                    <h1>Centro de Soporte</h1>
                    <p>Estamos aquí para ayudarte</p>
                </div>
                <div class="user-profile">
                    <div class="avatar-circle">{{ userInitials }}</div>
                    <div>
                        <p class="user-name">{{ userEmail }}</p>
                        <p class="user-role">Cliente</p>
                    </div>
                </div>
            </header>

            <!-- Tarjetas de contacto -->
            <section class="contact-grid">
                <!-- WhatsApp -->
                <div class="contact-card whatsapp">
                    <div class="contact-icon">
                        <ion-icon name="logo-whatsapp"></ion-icon>
                    </div>
                    <h3>WhatsApp</h3>
                    <p>Atención rápida y directa</p>
                    <a href="https://wa.me/34968909911?text=Hola%2C%20necesito%20ayuda%20con%20mi%20seguro" 
                       target="_blank" 
                       class="contact-btn btn-whatsapp">
                        <ion-icon name="logo-whatsapp"></ion-icon>
                        Chatear ahora
                    </a>
                    <span class="contact-hours">L-V 9:00 - 18:00</span>
                </div>

                <!-- Teléfono -->
                <div class="contact-card phone">
                    <div class="contact-icon">
                        <ion-icon name="call-outline"></ion-icon>
                    </div>
                    <h3>Teléfono</h3>
                    <p>Atención personalizada</p>
                    <a href="tel:968909911" class="contact-btn btn-phone">
                        <ion-icon name="call-outline"></ion-icon>
                        Llamar ahora
                    </a>
                    <span class="contact-hours">L-V 9:00 - 20:00</span>
                </div>

                <!-- Email -->
                <div class="contact-card email">
                    <div class="contact-icon">
                        <ion-icon name="mail-outline"></ion-icon>
                    </div>
                    <h3>Email</h3>
                    <p>Consulta escrita</p>
                    <a href="mailto:soporte@asisahealthvisa.com" class="contact-btn btn-email">
                        <ion-icon name="mail-outline"></ion-icon>
                        Enviar email
                    </a>
                    <span class="contact-hours">Respuesta < 24h</span>
                </div>
            </section>

            <!-- FAQ Rápidas -->
            <section class="faq-section">
                <h2>Preguntas frecuentes</h2>
                <div class="faq-list">
                    <div v-for="(faq, index) in faqs" :key="index" class="faq-item">
                        <div class="faq-question" @click="toggleFaq(index)">
                            <span>{{ faq.question }}</span>
                            <ion-icon :name="faqAbierto === index ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                        </div>
                        <div v-show="faqAbierto === index" class="faq-answer">
                            {{ faq.answer }}
                        </div>
                    </div>
                </div>
            </section>

            <!-- Información adicional -->
            <section class="info-section">
                <div class="info-box">
                    <ion-icon name="information-circle-outline"></ion-icon>
                    <div>
                        <strong>¿Emergencia médica?</strong>
                        <p>Llama al <a href="tel:112">112</a> o acude a tu centro médico más cercano</p>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
import Sidebar from '@/components/layout/Sidebar.vue'

export default {
    name: 'Soporte',
    components: { Sidebar },
    data() {
        return {
            userEmail: '',
            faqAbierto: null,
            faqs: [
                {
                    question: '¿Cómo descargo mi certificado de seguro?',
                    answer: 'Ve a "Mis Pólizas" y haz clic en el botón de descarga (icono de descarga) junto a la póliza que necesites.'
                },
                {
                    question: '¿Qué significa "En Revisión" en mi póliza?',
                    answer: 'Significa que nuestro equipo médico está revisando tu cuestionario de salud. Recibirás una respuesta en menos de 12 horas.'
                },
                {
                    question: '¿Cómo puedo renovar mi póliza?',
                    answer: 'Puedes renovar tu póliza desde el apartado "Vencimientos". Busca la póliza y haz clic en "Renovar Ahora".'
                },
                {
                    question: '¿Necesito cita previa para ir al médico?',
                    answer: 'Depende del centro. Puedes pedir cita a través de la app ASISA o llamando directamente al centro.'
                }
            ]
        }
    },
    computed: {
        userInitials() {
            return this.userEmail ? this.userEmail.substring(0, 2).toUpperCase() : 'CL'
        }
    },
    mounted() {
        this.verificarSesion()
    },
    methods: {
        verificarSesion() {
            const hash = localStorage.getItem('expat_visa_session')
            const user = localStorage.getItem('user')
            
            if (!hash || !user) {
                this.$router.push({ name: 'login' })
                return
            }
            
            this.userEmail = user
        },
        
        toggleFaq(index) {
            this.faqAbierto = this.faqAbierto === index ? null : index
        }
    }
}
</script>

<style scoped>
.dashboard-container {
    display: flex;
    min-height: 100vh;
    background: #f5f7fa;
}

.main-content {
    margin-left: 260px;
    flex-grow: 1;
    padding: 40px;
}

.header-dashboard {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.header-dashboard h1 {
    font-size: 1.8rem;
    color: #202124;
    margin-bottom: 5px;
}

.header-dashboard p {
    color: #5f6368;
}

.user-profile {
    display: flex;
    align-items: center;
    gap: 12px;
}

.avatar-circle {
    width: 40px;
    height: 40px;
    background: #1C4A8D;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    text-transform: uppercase;
}

.user-name {
    font-weight: 600;
    font-size: 0.9rem;
    margin: 0;
}

.user-role {
    font-size: 0.75rem;
    color: #5f6368;
    margin: 0;
}

/* Contact Grid */
.contact-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 25px;
    margin-bottom: 40px;
}

.contact-card {
    background: white;
    padding: 30px 20px;
    border-radius: 16px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    transition: transform 0.2s;
}

.contact-card:hover {
    transform: translateY(-5px);
}

.contact-icon {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    margin: 0 auto 15px;
}

.contact-card.whatsapp .contact-icon {
    background: #e6f4ea;
    color: #25d366;
}

.contact-card.phone .contact-icon {
    background: #e8f0fe;
    color: #1C4A8D;
}

.contact-card.email .contact-icon {
    background: #fff4e5;
    color: #ef6c00;
}

.contact-card h3 {
    margin-bottom: 8px;
    color: #202124;
}

.contact-card p {
    color: #5f6368;
    font-size: 0.85rem;
    margin-bottom: 20px;
}

.contact-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    font-weight: 600;
    text-decoration: none;
    margin-bottom: 12px;
    transition: all 0.2s;
}

.btn-whatsapp {
    background: #25d366;
    color: white;
}

.btn-whatsapp:hover {
    background: #1da15a;
}

.btn-phone {
    background: #1C4A8D;
    color: white;
}

.btn-phone:hover {
    background: #153a70;
}

.btn-email {
    background: #ef6c00;
    color: white;
}

.btn-email:hover {
    background: #cc5c00;
}

.contact-hours {
    font-size: 0.7rem;
    color: #5f6368;
}

/* FAQ Section */
.faq-section {
    background: white;
    border-radius: 16px;
    padding: 25px;
    margin-bottom: 40px;
}

.faq-section h2 {
    margin-bottom: 20px;
    color: #202124;
    font-size: 1.3rem;
}

.faq-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.faq-item {
    border: 1px solid #e1e4e8;
    border-radius: 12px;
    overflow: hidden;
}

.faq-question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 18px;
    cursor: pointer;
    background: white;
    font-weight: 500;
}

.faq-question:hover {
    background: #f8f9fa;
}

.faq-answer {
    padding: 20px 20px 40px;
    color: #5f6368;
    line-height: 1.5;
    border-top: 1px solid #e1e4e8;
}

/* Info Section */
.info-section {
    margin-bottom: 40px;
}

.info-box {
    background: #e8f0fe;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
}

.info-box ion-icon {
    font-size: 2rem;
    color: #1C4A8D;
}

.info-box a {
    color: #1C4A8D;
    text-decoration: none;
    font-weight: 600;
}

.info-box p {
    margin: 5px 0 0;
    color: #5f6368;
}

/* Responsive */
@media (max-width: 768px) {
    .main-content {
        margin-left: 80px;
        padding: 20px;
    }
    
    .contact-grid {
        grid-template-columns: 1fr;
    }
}
</style>